
(function ($) {
  const $readingTime = $('.read-time');
  let $fullText = ''

  function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

  if ($readingTime.length > 0) {
    const $content = document.querySelectorAll(".field--name-field-header p, .field--name-field-content p");
    const $titles = document.querySelectorAll('.field--name-field-content h2');

    if ($content.length > 0) {
      $content.forEach($paragraph => {
        $fullText = $fullText + $paragraph.innerText;
      });
    }

    if ($titles.length > 0) {
      $titles.forEach($title => {
        $fullText = $fullText + $title.innerText;
      });
    }

    if ($fullText.length > 0) {
      const wpm = 225;
      const wps = wpm / 60;
      const words = $fullText.trim().split(/\s+/).length;
      const time = Math.ceil(words / wps);
      const convertedTime = fmtMSS(time);
      $readingTime[0].innerText = "Leestijd " + convertedTime + " min"
    } else {
      $readingTime[0].innerText = "Leestijd: onbekend"
    }
  }

})(jQuery);
